// Query params that should be dropped when using the link form
export const QUERY_PARAMS_TO_REMOVE = [
    "widgetSize",

    // callbacks
    "autoClose",
    "autoSubmit",
    "autoSubmitOnError",
    "onSuccess",
    "onPending",
    "callback",
    "onError",
    "beforeClosing",
    "onTokenCreated",
    "onChargeCreated",
    "onSubscriptionCreated",
    "onThreeDsAuthorization",
    "onThreeDsAuthorizationSuccess",
    "onThreeDsAuthorizationFailure",
    "onThreeDsAuthorizationModalOpened",
    "onValidationError",
    "opened",
    "closed",

    //inline specifics
    "inline",
    "inlineStyles",
    "inlineBaseFontSize",
    "horizontalInlineLayout",
    "inlineFieldFocusStyle",
    "inlineFieldInvalidStyle",
    "inlineFieldStyle",
    "inlineItemErrorStyle",
    "inlineItemLabelStyle",
    "inlineItemStyle",
    "inlineTextFieldFocusStyle",
    "inlineTextFieldInvalidStyle",
    "inlineTextFieldStyle",
    "inlineTextItemErrorStyle",
    "inlineTextItemLabelStyle",
    "inlineTextItemStyle",
    "inlineToggleFieldFocusStyle",
    "inlineToggleFieldInvalidStyle",
    "inlineToggleFieldStyle",
    "inlineToggleItemErrorStyle",
    "inlineToggleItemLabelStyle",
    "inlineToggleItemStyle",
    "inlineSelectFieldStyle",
    "inlineSelectFieldInvalidStyle",
    "inlineSelectFieldFocusStyle",
    "inlineSelectItemStyle",
    "inlineSelectItemLabelStyle",
    "inlineSelectItemErrorStyle",
    "inlineRadioItemStyle",
    "inlineRadioItemLabelStyle",
    "inlineRadioFieldFocusStyle",

    "qrColor",
    "qrLogoType",
];

export const PARAMETER_KEY_MAPPING = {
    paymentTypes: "paymentMethods",
    tokenType: "type",
    capture: "auth",
    subscriptionInitialAmount: "initialAmount",
    subscriptionStart: "startOn",
    subscriptionStartIn: "startIn",
    installmentPlan: "installmentPlanType",
    subscriptionPeriod: "period",
    subscriptionPlan: "subscriptionPlanType",
    subscriptionStartDayOfMonth: "startDayOfMonth",
    email: "emailAddress",
    exp: "cardExpiry",
    installmentQty: "installmentCycles",
    subscriptionQty: "subscriptionCycles",

    // address
    shippingAddressLine1: "addressHouse",
    shippingAddressLine2: "addressHouseComplements",
    shippingAddressCity: "addressCity",
    shippingAddressState: "addressState",
    shippingAddressZip: "addressZipCode",
    shippingAddressCountryCode: "addressCountryCode",
    customerName: "name",
    customerNameKana: "nameKana",
    buyerName: "name",
    buyerNameKana: "nameKana",
    buyerDateOfBirth: "birthday",

    // product quantities
    productCodeQuantities: "productQuantities",

    // Metadata
    univapayReferenceId: "univapay-reference-id",
};

export const PARAMETER_VALUE_MAPPING = {
    auth: (capture: string) => (capture === "true" ? "false" : "true"),
};
